import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import ActionsModal from 'components/ActionsModal/ActionsModal'

import {
  selectDisplayedOrganization,
  updateDisplayedOrganization,
  closeDisplayedOrganization,
} from 'store/organizations'

import { selectOrganizations } from 'store/global'
import messages from './messages'

interface CreateOrganizationModalProps {
  onSubmit: (organization: any) => void | Promise<void>
}

export default function CreateOrganizationModal({ onSubmit }: CreateOrganizationModalProps) {
  const dispatch = useDispatch()

  const allOrganizations = useSelector(selectOrganizations)
  const displayedOrganization = useSelector(selectDisplayedOrganization)

  const onFieldChange = (key: string, value: any) => dispatch(updateDisplayedOrganization({ key, value }))

  const onCloseModal = () => dispatch(closeDisplayedOrganization())

  const isOrganizationNameAvailable = (name: string): boolean =>
    allOrganizations.every((organization: any) => organization.name !== name)

  const isOrganizationAliasAvailable = (alias: string): boolean =>
    allOrganizations.every((organization: any) => organization.alias !== alias)

  const isOrganizationDomainsAvailable = (domains: string): boolean =>
    allOrganizations.every((organization: any) => organization.domains !== domains)

  const fields = {
    name: {
      key: 'name',
      isRequired: true,
      label: <FormattedMessage {...(messages.labels as any).name} />,
      validator: isOrganizationNameAvailable,
      formFeedback: <FormattedMessage {...(messages.formFeedback as any).nameUnavailable} />,
    },
    alias: {
      key: 'alias',
      isRequired: true,
      validator: isOrganizationAliasAvailable,
      label: <FormattedMessage {...(messages.labels as any).alias} />,
    },
    domains: {
      key: 'domains',
      isRequired: true,
      validator: isOrganizationDomainsAvailable,
      label: <FormattedMessage {...(messages.labels as any).domains} />,
    },
  }

  const handleSubmit = () => {
    onSubmit(displayedOrganization)
  }

  return (
    <ActionsModal
      type='organization'
      mode='create'
      item={displayedOrganization}
      primaryKey='name'
      fields={fields}
      onFieldChange={onFieldChange}
      onClose={onCloseModal}
      onSubmit={handleSubmit}
    />
  )
}

